import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Config } from '../../config/config';

@Injectable({
  providedIn: 'root'
})
export class PendenciaService {

  private _config: Config = new Config();

  constructor(private http: HttpClient) { }

    /**
   *
   * @param filtros
   * @param page
   * @param perPage
   */
  public listar(filtros: object = null, page: number|string = 1, perPage: number|string = null): Observable<any> {
    perPage = perPage === undefined ? '' : perPage;
    let params = new HttpParams();
    params = params.append('page', page.toString());
    if (filtros != null) {
        Object.keys(filtros).forEach(filter => {
            if (Array.isArray(filtros[filter])) {
                filtros[filter].forEach((value, key) => {
                    params = params.append(`${filter}[${key}]`, value);
                });
            } else {
                params = params.append(filter, filtros[filter]);
            }
        });
    }
    return this.http.get<any>(`${this._config.get('urlServiceBackend')}monitor/pendencia/listar${perPage != null ? '/' + perPage : ''}`, {
        params: params
    });
  }

  public listarEstatisticaGeral(): Observable<any> {
      return this.http.get<any>(`${this._config.get('urlServiceBackend')}monitor/pendencia/listar/estatistica/geral`);
  }
}
